export default __webpack_public_path__ + "static/media/computer.06141a95.svg";